if (!customElements.get('tp-product-variants-meta')) {
  class TpProductVariantsMeta extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.tp-product-variants-meta__overlay');
      this.spinner = this.querySelector('.loading__spinner');
    }

    connectedCallback() {
      this.querySelectorAll('.tp-product-variants-meta__item').forEach((item) => {
        item.addEventListener('click', this.handleClick.bind(this));
      });
    }

    async handleClick(event) {
      event.preventDefault();
      const item = event.currentTarget;
      const url = item.dataset.productUrl;

      if (!url || item.classList.contains('tp-product-variants-meta__item--active')) return;

      this.showLoading();

      try {
        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) throw new Error('Fetch failed');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProductInfo = doc.querySelector('product-info');
        const currentProductInfo = document.querySelector('product-info');

        if (newProductInfo && currentProductInfo) {
          // Update URL without reload
          history.replaceState({}, '', url);

          // Swap the product-info content
          currentProductInfo.innerHTML = newProductInfo.innerHTML;

          // Copy attributes
          Array.from(newProductInfo.attributes).forEach((attr) => {
            currentProductInfo.setAttribute(attr.name, attr.value);
          });

          // Re-run scripts inside the new content
          currentProductInfo.querySelectorAll('script').forEach((oldScript) => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attr) => {
              newScript.setAttribute(attr.name, attr.value);
            });
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });

          // Trigger Shopify payment button init
          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          // Update page title
          const newTitle = doc.querySelector('title');
          if (newTitle) document.title = newTitle.textContent;
        }
      } catch (error) {
        console.error('[tp-product-variants-meta] Error loading product:', error);
        window.location.href = url;
      } finally {
        this.hideLoading();
      }
    }

    showLoading() {
      if (this.overlay) {
        this.overlay.classList.add('tp-product-variants-meta__overlay--visible');
        this.spinner.classList.remove('hidden'); 
      }
    }

    hideLoading() {
      // Re-query overlay since innerHTML was replaced
      const overlay = document.querySelector('.tp-product-variants-meta__overlay');
      if (overlay) {
        overlay.classList.remove('tp-product-variants-meta__overlay--visible');
        this.spinner.classList.add('hidden');
      }
    }
  }

  customElements.define('tp-product-variants-meta', TpProductVariantsMeta);
}
